import { getCurrentInstance } from 'vue';

export default function useEmitter() {
  const internalInstance = getCurrentInstance();
  // @ts-ignore
  return internalInstance.appContext.config.globalProperties.emitter;
}
